import React, { useState } from 'react';
import { SlButton } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/SlButton';
import { useBeaconNavigator } from 'src/components/BeaconV2Components/BeaconNavigation/useBeaconNavigator';
import { BEACON_SUBTABS, BEACON_TABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import WarningModal, { WarningModalVariant } from 'src/components/Modals/WarningModal';
import colors from 'src/utils/colors';
import { checkCreditBalance } from 'src/utils/creditsApi';
import { useDivisionId } from 'src/utils/Hooks/reduxSelectors';
import { useContentGenerationStore } from '../Generate/components/ProductTable/store';
import { useProjects } from './hooks/useProjects';

export const AddProjectButton: React.FC = () => {
  const { beaconNavigator } = useBeaconNavigator();
  const { clearSelection } = useContentGenerationStore();
  const { clearProjectFlow } = useProjects();
  const divisionId = useDivisionId();
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [warningVariant, setWarningVariant] = useState<WarningModalVariant>('noActiveContracts');
  const [isCheckingBalance, setIsCheckingBalance] = useState(false);

  const handleClick = async () => {
    setIsCheckingBalance(true);
    try {
      const balanceResponse = await checkCreditBalance(divisionId);

      if (!balanceResponse.canProceed) {
        if (!balanceResponse.hasActiveContract) {
          setWarningVariant('noActiveContracts');
        } else {
          setWarningVariant('noCreditBalance');
        }
        setIsWarningOpen(true);
        return;
      }
    } catch {
      // Allow proceeding if balance check fails
    } finally {
      setIsCheckingBalance(false);
    }

    clearSelection();
    clearProjectFlow();
    beaconNavigator.updateSearchParams({ 
      tab: BEACON_TABS.PROJECTS, 
      subtab: BEACON_SUBTABS.PROJECTS_SETTINGS 
    });
    beaconNavigator.go();
  };

  return (
    <>
      <SlButton
        onClick={handleClick}
        disabled={isCheckingBalance}
        textSx={{ color: 'white' }}
        buttonSx={{
          backgroundColor: colors.darkBlue,
          borderRadius: '4px',
          border: `1px solid ${colors.darkBlue}`,
          padding: '0 20px',
          '&:hover': {
            backgroundColor: '#68727C',
            border: '1px solid #68727C'
          }
        }}
      >
        + Add Project
      </SlButton>
      <WarningModal isOpen={isWarningOpen} setIsOpen={setIsWarningOpen} variant={warningVariant} featureName="Generations" />
    </>
  );
};

